<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Ausstattung</h2>
      <p class="step-text">Wie ist die Wohnung ausgestattet?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          :text="getAusstattungNameWhg(90)"
          @click="setAusstattung(90)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8521.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8521_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          :text="getAusstattungNameWhg(80)"
          @click="setAusstattung(80)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8555.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8555_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          :text="getAusstattungNameWhg(60)"
          @click="setAusstattung(60)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8011.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8011_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          :text="getAusstattungNameWhg(50)"
          @click="setAusstattung(50)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8553.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8553_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          :text="getAusstattungNameWhg(20)"
          @click="setAusstattung(20)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8009.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8009_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from '@/components/shared/ActionBox.vue';
import {
  saveToStorage,
  getAusstattungName,
} from '@/utils.js';
export default {
  name: 'wohnung-step-7',
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexWhgAusstattung: { value: null },
      },
    };
  },
  methods: {
    setAusstattung(index) {
      this.fields.indexWhgAusstattung.value = index;
      saveToStorage(this.fields);
      this.$router.push('/wohnung-step-8a');
    },
    getAusstattungNameWhg(id) {
      let name = getAusstattungName(id);
      return name;
    },
    goBack() {
        this.$router.push('/wohnung-step-6');
    },
  },
  mounted() {
    this.$emit('setStep', 'wohnung', 8);
  },
};
</script>
